import quotation_link from './quotation_link.vue'
const QuotationLink = {
    install: function (Vue) {
        Vue.component('QuotationLink', quotation_link)
    }
}
export default QuotationLink
